import { signUpRouteValidator } from '@frontend/member-route-validators';
import { AppShell } from '@frontend/web-react';
import {
  AppContentWrapper,
  OnboardingLogoutButton,
  OnboardingPageWrapper,
  UnauthenticatedAppHeader,
} from '@frontend/web/components';
import { createFileRoute, handleRedirectBeforeLoad } from '@frontend/web/utils';
import { MembershipWizard } from '../../components/DomainSpecific/Onboarding/Membership';

const Membership = () => {
  const searchParams = Route.useSearch();

  return (
    <AppShell>
      <UnauthenticatedAppHeader linkTo={false} rightContent={<OnboardingLogoutButton step="membership" />} />
      <AppContentWrapper className="flex-1">
        <OnboardingPageWrapper currentStep="membership">
          <MembershipWizard overridePromoCode={searchParams.promo} />
        </OnboardingPageWrapper>
      </AppContentWrapper>
    </AppShell>
  );
};

export const Route = createFileRoute('/onboarding/membership')({
  beforeLoad: async ({ context, location }) => {
    handleRedirectBeforeLoad({ context, location });
  },
  component: Membership,
  validateSearch: signUpRouteValidator,
});
